import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { ErrorMessages } from '@types';
import { parseZodErrors, scrollTop, textAreaInputSchema } from '@utils';
import { ZodError } from 'zod';

export const VandalismTellUsMore = () => {
  const { updateVandalismTellUsMoreText, vandalismTellUsMoreText } =
    useCycleStore();
  const [textInput, setTextInput] = useState(vandalismTellUsMoreText);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const MAX_LENGTH = 500;
  const pageTitle = 'Tell us how the damage or vandalism happened';
  const errorPath = 'vandalismTellUsMore';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextInput(event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        textAreaInputSchema({
          fieldName: errorPath,
          requiredMessage: 'Enter details about the damage or vandalism.',
          maxLength: MAX_LENGTH,
          maxLengthMessage: `Details about the damage or vandalism must be 500 characters or less.`,
        }).parse({
          [errorPath]: textInput,
        });

        updateVandalismTellUsMoreText(textInput);

        navigate(RoutesList.TELL_US_MORE);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.DAMAGED_OR_VANDALISED);
      scrollTop();
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={textInput}
      labelText={pageTitle}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
